import { render, staticRenderFns } from "./ManagePhotos.vue?vue&type=template&id=a0d1b33a&scoped=true"
import script from "./ManagePhotos.vue?vue&type=script&lang=js"
export * from "./ManagePhotos.vue?vue&type=script&lang=js"
import style0 from "./ManagePhotos.vue?vue&type=style&index=0&id=a0d1b33a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d1b33a",
  null
  
)

export default component.exports